import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactInformation from "./sections/ContactInformation";
import MultipleRequestForms from "./sections/MultipleRequestForms";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <Hero />
      <ContactInformation />
      <MultipleRequestForms />
      <Footer />
    </div>;
}